import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Typography } from '@cp/ds/src/components/typography';
import { Box } from '@cp/ds/src/components/box';
import { PriceProps } from './model';

const SPACING = 1.5;

export const Price: React.FC<PriceProps> = ({ data, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={mergeSx(
        {
          p: SPACING / 2,
          px: 1.5,
          py: 0.75,
          display: 'inline-block',
          border: `1px solid ${theme.palette['gray light']}`,
          borderRadius: '8px',
          backgroundColor: theme.palette.white,
        },
        sx,
      )}
    >
      <Typography variant="body bold">{data} руб/час</Typography>
    </Box>
  );
};
